<template>
    <div class="course-index">
        <div class="header">
            <div class="section-content" style="width:990px">
                <div style="font-weight: 600;font-size: 30px"><span style="font-size: 36px;">SHICHIDA </span> programs</div>
                <div class="qtz-course">七田真课程</div>
                <ul class="course-detail">
                    <li>七田真经过65年教学实践的积累，</li>
                    <li>独创了严谨、细致、科学的720篇教案，2000多种特色教具，</li>
                    <li>形成了一套切实可行的开发脑力潜质的教学体系。</li>
                </ul>
            </div>
        </div>

        <div class="section-content">
            <div style="width: 990px;margin: 0 auto;margin-bottom:40px;">
                <button class="page-btn">课程种类</button>
            </div>
            <div>
                <img src="../../assets/imgs/course/xueTop.png" style="margin: 0 auto;display: block" alt="">
            </div>
            <div>
                <img src="https://smart-resource.sikegroup.com/course-type-12-16-1.c773d44c.png" style="margin: 0 auto;display: block" alt="">
            </div>
            <div>
                <img src="../../assets/imgs/course/xiBottom.png" style="margin: 20px auto;display: block" alt="">
            </div>
            <div>
                <img src="https://sk-ims-cabinet.sikegroup.com/FrrF9p46Crvjaz3-HVbvMMAEgpqd" style="margin: 0 auto;display: block" alt="">
            </div>
            <div style="width: 990px;margin: 40px auto;padding-bottom:20px;border-bottom: 2px dashed #CECECD;margin-top: 50px;">
                <button class="page-btn">学阶介绍</button>
            </div>
        </div>

        <div class="section-content">
            <img src="https://smart-resource.sikegroup.com/course-type-12-16-2.7f2839b3.png" style="width: 100%;margin-bottom: 40px;" alt="">
        </div>


    </div>
</template>

<script>
    export default {
        name: "course-index",
        data(){
            return {

            }
        }
    }
</script>

<style lang="less">
    .course-index{
        font-weight: normal;
        .header{
            width: 100%;
            height: 440px;
            padding-top: 80px;
            margin-bottom: 40px;
            background: url("../../assets/imgs/course/course-title-bg.png") no-repeat;
            background-size: cover;
            color: #fff;
            .qtz-course{
                line-height: 1;
                font-weight: 600;
                font-size: 36px;
                margin-bottom: 40px;
            }
            .course-detail{
                font-size: 18px;
            }
        }
        .page-btn{
            padding: 8px 25px;
            font-weight: 600;
            font-size: 25px;
            background: #F8B634;
            color: #fff;
            border-radius: 10px;
            border: none;
            outline: none;
        }
    }
</style>
